import {put, takeEvery, all, call} from 'redux-saga/effects';
import * as apis from "./apis";
import {TRAINING_SESSION_PARTICIPANT_UPDATE} from "./constants";
import {getPlayers} from "../trainingSession/actions";
function* handler(action,api,data) {
    try {
        const resJson = yield call(api,data.payload);
        yield put({ type: action.SUCCESS, payload: { data: resJson } });
        if (action === TRAINING_SESSION_PARTICIPANT_UPDATE){
            yield put(getPlayers({
                id:data.payload.sessionId
            }));
        }
    } catch (err) {
        yield put({ type: action.FAIL, payload: { error: err.message } });
    }
}

function* callGenerator(action,api) {
    yield takeEvery(action.REQUEST, handler,action,api);
}

export default function* trainingSessionSaga() {
    yield all([
        callGenerator(TRAINING_SESSION_PARTICIPANT_UPDATE,apis.update),
    ]);
}